const delay = <T extends unknown>(
  ms: number,
  data: T,
): Promise<T> => new Promise(resolve => { setTimeout(resolve, ms, data); });
export default delay;
